import { render } from "./CalendarMonth.vue?vue&type=template&id=fa278bcc&scoped=true"
import script from "./CalendarMonth.vue?vue&type=script&lang=js"
export * from "./CalendarMonth.vue?vue&type=script&lang=js"

import "./CalendarMonth.vue?vue&type=style&index=0&id=fa278bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa278bcc"]])

export default __exports__